import styled from 'styled-components';
import media from 'styled-media-query';

export const ColumnContent = styled.div`
    display: flex;

	${media.lessThan('medium')`
		flex-direction: column;
	`}
`;

export const ColumnContentSmall = styled.div`
    ${media.lessThan('medium')`
		${({showAfter}) => showAfter && 'order: 1;'}
        ${({mobileHidden}) => mobileHidden && 'display: none;'}
	`}

    ${media.greaterThan('medium')`
		margin-right: 10%;
        width: 25%;
	`}
`;

export const ColumnContentSmallTitle = styled.div`
    color: var(--main-color);
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
`;

export const ColumnContentLarge = styled.div`
    ${media.greaterThan('medium')`
		padding-left: 1rem;
        width: 65%;
	`}
`;

export const ColumnContentLargeTitle = styled.div`
    color: var(--main-color);
    font-size: 2rem;
    margin-bottom: 1.5rem;
`;
